"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComplexFeatureFlag = void 0;
const react_1 = __importDefault(require("react"));
const CoreFeaturesContext_1 = require("./CoreFeaturesContext");
/**
 * Use this hook if your flag is expected to return non-boolean values.
 * @param flag flag key from Eppo
 */
function useComplexFeatureFlag(flagKey) {
    const context = react_1.default.useContext(CoreFeaturesContext_1.CoreFeaturesContext);
    const flagValue = context.getFeatureFlagAssignment(flagKey);
    if (context === undefined) {
        throw new Error('useComplexFeatureFlag must be used within a CoreFeaturesProvider');
    }
    return {
        isLoading: context.isLoading,
        assignment: context.isLoading ? undefined : flagValue,
    };
}
exports.useComplexFeatureFlag = useComplexFeatureFlag;
